import React from 'react';
import PropTypes from 'prop-types';
import FormTextContainer from '../../../redux/containers/FormTextContainer';
import FormRadioGroupContainer from '../../../redux/containers/FormRadioGroupContainer';
import DayMonthYear from '../DayMonthYear/DayMonthYear';
import PersonalIdentificationType from '../../../model/PersonalIdentificationType';
import IdentificationHint from './IdentificationHint';
import CreditAssessmentErrorMessage from '../CreditAssessmentErrorMessage/CreditAssessmentErrorMessage';

const PersonalIdentification = props =>
  <section>
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <h3 className="half-charcoal">Identification</h3>
        </div>
      </div>
      <CreditAssessmentErrorMessage caError={props.caError} />
      <div className="row">
        <div className="col-sm-12">
          <div className="form-input-container relative">
            <p>Please select your ID type <span className="form-required-text">*</span></p>
            <FormRadioGroupContainer
              name="creditAssessment.personalIdentificationType"
              radioButtons={[{
                id: PersonalIdentificationType.NZ_DRIVER_LICENSE,
                label: 'NZ Drivers License',
                autotestClass: 'autotest-ca-is-nz-drivers-license'
              }, {
                id: PersonalIdentificationType.NZ_PASSPORT,
                label: 'NZ Passport',
                autotestClass: 'autotest-ca-id-nz-passport'
              }]}
            />
          </div>
        </div>
      </div>
      {props.personalIdentificationType === PersonalIdentificationType.NZ_DRIVER_LICENSE &&
      <div>
        <div className="row">
          <div className="col-sm-6">
            <FormTextContainer
              name="creditAssessment.nzDriverLicense.licenseNumber"
              label="License"
              placeholder="License Number e.g. DL555999"
              autotestClass="autotest-ca-driver-licence-number"
              maxLength={8}
              required
            />
          </div>
          <div className="col-sm-6">
            <FormTextContainer
              name="creditAssessment.nzDriverLicense.licenseVersionNumber"
              label="Version"
              placeholder="License Version e.g. 111"
              autotestClass="autotest-ca-driver-licence-version"
              maxLength={3}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <DayMonthYear
              name="creditAssessment.nzDriverLicense.expiryDate"
              label="Drivers License Expires"
              autotestClass="autotest-passport-expiry-date"
              required
            />
          </div>
        </div>
      </div>
      }
      {props.personalIdentificationType === PersonalIdentificationType.NZ_PASSPORT &&
      <div>
        <div className="row">
          <div className="col-sm-6">
            <FormTextContainer
              name="creditAssessment.nzPassport.passportNumber"
              label="Passport No. | Tau Uruwhenua"
              placeholder="Passport No. | Tau Uruwhenua e.g. LA001801"
              autotestClass="autotest-ca-passport-number"
              maxLength={8}
              required
            />
          </div>
          <div className="col-sm-6" />
        </div>
        <div className="row">
          <div className="col-sm-12">
            <DayMonthYear
              name="creditAssessment.nzPassport.expiryDate"
              label="Date of Expiry | Rā Mutunga"
              autotestClass="autotest-passport-expiry-date"
              required
            />
          </div>
        </div>
      </div>
      }
      {props.personalIdentificationType &&
      <IdentificationHint personalIdentificationType={props.personalIdentificationType} />
      }
    </div>
  </section>
;

PersonalIdentification.propTypes = {
  personalIdentificationType: PropTypes.string,
  caError: PropTypes.object
};

export default PersonalIdentification;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/PersonalIdentification/PersonalIdentification.js
 **/